import React, { useEffect } from "react";
import { Loading } from "components/common";
import { useQuery } from "@apollo/react-hooks";
import { track } from "utils";
import { GET_PRODUCT_STATUS } from "./mutations";

const BoostWaiting = ({ history }) => {
  const { data, stopPolling } = useQuery(GET_PRODUCT_STATUS, {
    fetchPolicy: "network-only",
    pollInterval: 3000,
  });

  useEffect(() => {
    track("TOMO_BOOST_DASHBOARD_WAITING");
  }, []);

  useEffect(() => {
    if (data?.getUserProductStatus?.status === "enrolled") {
      stopPolling();
      const queryParams = new URLSearchParams(history.location.search);
      queryParams.delete("status");
      queryParams.append("status", "enrolled");
      history.replace({
        search: queryParams.toString(),
      });
    }
  }, [data, history, stopPolling]);

  return (
    <div>
      <Loading boost />
    </div>
  );
};

export default BoostWaiting;
